/**
 * MODELOS PRÉ-CONFIGURADOS DE COMPLEMENTOS POR NICHO — MATAFOME
 * 
 * Regra de Arquitetura:
 * Estes dados são SUGESTÕES INICIAIS de configuração para acelerar o onboarding.
 * Na interface administrativa (UI), NÃO são utilizados emojis (apenas ícones SVG).
 * Nas mensagens de comunicação externa / WhatsApp, os emojis são mantidos e valorizados.
 */

export const NICHE_TEMPLATES = [
    {
        id: 'hamburgueria',
        name: 'Hamburgueria & Lanches',
        badge: 'Mais Popular',
        svgIcon: 'burger',
        themeColor: '#EA580C',
        description: 'Smash burgers, artesanais, combos e porções.',
        botMessages: {
            welcome: 'Fala, {nome_cliente}! 🍔 Seja muito bem-vindo ao {nome_loja}! Bateu aquela fome de um burger artesanal suculento? Dá uma olhada no nosso cardápio digital no link abaixo: 👇',
            upsell: 'Dica do chef: que tal turbinar seu burger com nosso bacon crocante artesanal ou adicionar uma porção de batata rústica com maionese da casa? 🍟🥓'
        },
        groups: [
            {
                key: 'ponto_carne',
                name: 'Ponto da Carne',
                badge: '1 escolha obrigatória',
                required: true,
                min_choice: 1,
                max_choice: 1,
                free_choices: 1,
                defaultSelected: true,
                items: [
                    { name: 'Bem passado', price: 0, defaultSelected: true },
                    { name: 'Ao ponto', price: 0, defaultSelected: true },
                    { name: 'Ao ponto para menos', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'adicionais_burger',
                name: 'Adicionais do Burger',
                badge: 'Múltiplas escolhas',
                required: false,
                min_choice: 0,
                max_choice: 10,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Bacon crocante', price: 4.00, defaultSelected: true },
                    { name: 'Cheddar duplo', price: 5.00, defaultSelected: true },
                    { name: 'Hambúrguer extra 160g', price: 8.00, defaultSelected: true },
                    { name: 'Ovo frito', price: 2.50, defaultSelected: true },
                    { name: 'Cebola caramelizada', price: 3.50, defaultSelected: true }
                ]
            },
            {
                key: 'queijos',
                name: 'Queijos',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 5,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Cheddar', price: 0, defaultSelected: true },
                    { name: 'Muçarela', price: 0, defaultSelected: true },
                    { name: 'Prato', price: 0, defaultSelected: true },
                    { name: 'Gorgonzola', price: 3.00, defaultSelected: true }
                ]
            },
            {
                key: 'molhos',
                name: 'Molhos',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 5,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Maionese da casa', price: 0, defaultSelected: true },
                    { name: 'Barbecue defumado', price: 0, defaultSelected: true },
                    { name: 'Molho especial', price: 0, defaultSelected: true },
                    { name: 'Molho de alho', price: 0, defaultSelected: true },
                    { name: 'Molho picante', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'complementos_salada',
                name: 'Complementos',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 5,
                free_choices: 0,
                defaultSelected: false,
                items: [
                    { name: 'Cebola roxa', price: 0, defaultSelected: true },
                    { name: 'Picles', price: 0, defaultSelected: true },
                    { name: 'Jalapeño', price: 0, defaultSelected: true },
                    { name: 'Cebola crispy', price: 0, defaultSelected: true }
                ]
            }
        ]
    },
    {
        id: 'pizzaria',
        name: 'Pizzaria & Massas',
        badge: 'Tradição',
        svgIcon: 'pizza',
        themeColor: '#DC2626',
        description: 'Pizzas individuais, grandes, massas artesanais e calzones.',
        botMessages: {
            welcome: 'Olá, {nome_cliente}! 🍕 Seja muito bem-vindo à {nome_loja}!\n\nPizza quentinha saindo do forno a lenha! 🔥',
            upsell: 'Uma pizza dessas pede uma borda vulcão recheada de Catupiry original e um refrigerante bem gelado para acompanhar! 🍕🥤'
        },
        groups: [
            {
                key: 'tamanho_massa',
                name: 'Tamanho / Massa',
                badge: '1 escolha obrigatória',
                required: true,
                min_choice: 1,
                max_choice: 1,
                free_choices: 1,
                defaultSelected: true,
                items: [
                    { name: 'Tradicional', price: 0, defaultSelected: true },
                    { name: 'Fina e crocante', price: 0, defaultSelected: true },
                    { name: 'Pan', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'borda_recheada',
                name: 'Borda Recheada',
                badge: '1 escolha opcional',
                required: false,
                min_choice: 0,
                max_choice: 1,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Sem borda', price: 0, defaultSelected: true },
                    { name: 'Catupiry', price: 8.00, defaultSelected: true },
                    { name: 'Cheddar cremoso', price: 8.00, defaultSelected: true },
                    { name: 'Chocolate', price: 10.00, defaultSelected: true }
                ]
            },
            {
                key: 'adicionais_cobertura',
                name: 'Adicionais de Cobertura',
                badge: 'Múltiplas escolhas',
                required: false,
                min_choice: 0,
                max_choice: 10,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Queijo extra', price: 6.00, defaultSelected: true },
                    { name: 'Bacon', price: 5.00, defaultSelected: true },
                    { name: 'Calabresa', price: 5.00, defaultSelected: true },
                    { name: 'Frango', price: 5.00, defaultSelected: true },
                    { name: 'Milho', price: 3.00, defaultSelected: true },
                    { name: 'Cebola', price: 2.00, defaultSelected: true },
                    { name: 'Azeitona', price: 3.00, defaultSelected: true },
                    { name: 'Tomate', price: 2.50, defaultSelected: true },
                    { name: 'Alho frito', price: 3.00, defaultSelected: true }
                ]
            },
            {
                key: 'finalizacao',
                name: 'Finalização',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 4,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Orégano', price: 0, defaultSelected: true },
                    { name: 'Manjericão', price: 0, defaultSelected: true },
                    { name: 'Azeite', price: 0, defaultSelected: true },
                    { name: 'Pimenta', price: 0, defaultSelected: true }
                ]
            }
        ]
    },
    {
        id: 'acaiteria',
        name: 'Açaíteria',
        badge: 'Refrescante',
        svgIcon: 'bowl',
        themeColor: '#7C3AED',
        description: 'Copos, tigelas, barcas e adicionais por camadas.',
        botMessages: {
            welcome: 'Oie, {nome_cliente}! 🍓 Seja muito bem-vindo ao {nome_loja}! Hora de se refrescar com o melhor açaí da região! Monte seu copo com frutas frescas e adicionais no link: 👇',
            upsell: 'Dica especial: já experimentou colocar Nutella pura ou KitKat picado no seu açaí? Fica irresistível! 🍫✨'
        },
        groups: [
            {
                key: 'acompanhamentos_inclusos',
                name: 'Acompanhamentos Inclusos',
                badge: 'Até 3 escolhas grátis',
                required: false,
                min_choice: 0,
                max_choice: 3,
                free_choices: 3,
                defaultSelected: true,
                items: [
                    { name: 'Granola', price: 0, defaultSelected: true },
                    { name: 'Leite Ninho', price: 0, defaultSelected: true },
                    { name: 'Paçoca', price: 0, defaultSelected: true },
                    { name: 'Banana', price: 0, defaultSelected: true },
                    { name: 'Morango', price: 0, defaultSelected: true },
                    { name: 'Coco ralado', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'coberturas_acai',
                name: 'Coberturas',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 5,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Leite condensado', price: 0, defaultSelected: true },
                    { name: 'Calda de chocolate', price: 0, defaultSelected: true },
                    { name: 'Calda de morango', price: 0, defaultSelected: true },
                    { name: 'Mel', price: 0, defaultSelected: true },
                    { name: 'Calda de caramelo', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'extras_premium_acai',
                name: 'Extras Premium',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 10,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Nutella', price: 5.00, defaultSelected: true },
                    { name: 'KitKat', price: 4.00, defaultSelected: true },
                    { name: 'Gotas de chocolate', price: 3.00, defaultSelected: true },
                    { name: 'Leite Ninho extra', price: 2.50, defaultSelected: true },
                    { name: 'Ovomaltine', price: 3.50, defaultSelected: true }
                ]
            },
            {
                key: 'frutas_acai',
                name: 'Frutas',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 4,
                free_choices: 0,
                defaultSelected: false,
                items: [
                    { name: 'Morango', price: 0, defaultSelected: true },
                    { name: 'Banana', price: 0, defaultSelected: true },
                    { name: 'Kiwi', price: 0, defaultSelected: true },
                    { name: 'Uva', price: 0, defaultSelected: true }
                ]
            }
        ]
    },
    {
        id: 'sorveteria',
        name: 'Sorveteria',
        badge: 'Sobremesas',
        svgIcon: 'ice-cream',
        themeColor: '#EC4899',
        description: 'Casquinhas, cascões, potes, taças e milkshakes.',
        botMessages: {
            welcome: 'Olá, {nome_cliente}! 🍦 Seja bem-vindo à {nome_loja}! Bateu vontade daquele sorvete cremoso? Escolha seus sabores e coberturas favoritas no cardápio abaixo: 👇',
            upsell: 'Que tal adicionar uma cobertura especial de chocolate quente e castanhas crocantes na sua taça? 🍨🍫'
        },
        groups: [
            {
                key: 'sabores_sorvete',
                name: 'Sabores',
                badge: '1 a 3 escolhas obrigatórias',
                required: true,
                min_choice: 1,
                max_choice: 3,
                free_choices: 3,
                defaultSelected: true,
                items: [
                    { name: 'Chocolate Tradicional', price: 0, defaultSelected: true },
                    { name: 'Morango Silvestre', price: 0, defaultSelected: true },
                    { name: 'Creme Baunilha', price: 0, defaultSelected: true },
                    { name: 'Flocos', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'coberturas_sorvete',
                name: 'Coberturas',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 5,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Chocolate', price: 0, defaultSelected: true },
                    { name: 'Morango', price: 0, defaultSelected: true },
                    { name: 'Caramelo', price: 0, defaultSelected: true },
                    { name: 'Leite condensado', price: 0, defaultSelected: true },
                    { name: 'Chocolate branco', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'complementos_sorvete',
                name: 'Complementos',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 5,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Granulado', price: 0, defaultSelected: true },
                    { name: 'Confete', price: 0, defaultSelected: true },
                    { name: 'Paçoca', price: 0, defaultSelected: true },
                    { name: 'Ovomaltine', price: 0, defaultSelected: true },
                    { name: 'Coco ralado', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'frutas_sorvete',
                name: 'Frutas',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 4,
                free_choices: 0,
                defaultSelected: false,
                items: [
                    { name: 'Morango', price: 0, defaultSelected: true },
                    { name: 'Banana', price: 0, defaultSelected: true },
                    { name: 'Uva', price: 0, defaultSelected: true },
                    { name: 'Kiwi', price: 0, defaultSelected: true }
                ]
            }
        ]
    },
    {
        id: 'japones',
        name: 'Sushi / Japonês',
        badge: 'Oriental',
        svgIcon: 'sushi',
        themeColor: '#E11D48',
        description: 'Combinados, sushis, temakis e pratos orientais.',
        botMessages: {
            welcome: 'Kon\'nichiwa, {nome_cliente}! 🥢 Seja bem-vindo ao {nome_loja}! Sushis frescos, temakis e combinados preparados na hora. Acesse nosso cardápio digital para fazer seu pedido: 👇',
            upsell: 'Recomendação do sushiman: nosso Cream Cheese maçaricado com crispy de couve combina perfeitamente com seu pedido! 🍣✨'
        },
        groups: [
            {
                key: 'molhos_japones',
                name: 'Molhos e Acompanhamentos',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 5,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Shoyu', price: 0, defaultSelected: true },
                    { name: 'Tarê', price: 0, defaultSelected: true },
                    { name: 'Wasabi', price: 0, defaultSelected: true },
                    { name: 'Gengibre', price: 0, defaultSelected: true },
                    { name: 'Molho picante', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'utensilios_japones',
                name: 'Utensílios',
                badge: '1 escolha obrigatória',
                required: true,
                min_choice: 1,
                max_choice: 1,
                free_choices: 1,
                defaultSelected: true,
                items: [
                    { name: 'Preciso de Hashi', price: 0, defaultSelected: true },
                    { name: 'Não preciso de Hashi', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'adicionais_japones',
                name: 'Adicionais',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 6,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Cream cheese', price: 0, defaultSelected: true },
                    { name: 'Cream cheese maçaricado', price: 3.00, defaultSelected: true },
                    { name: 'Crispy de couve', price: 2.50, defaultSelected: true },
                    { name: 'Cebolinha', price: 0, defaultSelected: true },
                    { name: 'Gergelim', price: 0, defaultSelected: true },
                    { name: 'Geleia de pimenta', price: 3.00, defaultSelected: true }
                ]
            }
        ]
    },
    {
        id: 'marmitaria',
        name: 'Marmitaria / Almoço',
        badge: 'Comida Caseira',
        svgIcon: 'bento',
        themeColor: '#D97706',
        description: 'Marmitex, pratos executivos e comida caseira.',
        botMessages: {
            welcome: 'Olá, {nome_cliente}! 🍱 Seja bem-vindo à {nome_loja}! Almoço caseiro, quentinho e com aquele tempero especial! Veja o cardápio do dia e monte sua marmita no link: 👇',
            upsell: 'Dica do dia: que tal adicionar um ovo frito com gema mole ou uma porção extra de torresmo crocante? 🍳🥓'
        },
        groups: [
            {
                key: 'escolha_arroz',
                name: 'Escolha do Arroz',
                badge: '1 escolha obrigatória',
                required: true,
                min_choice: 1,
                max_choice: 1,
                free_choices: 1,
                defaultSelected: true,
                items: [
                    { name: 'Arroz branco', price: 0, defaultSelected: true },
                    { name: 'Arroz integral', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'escolha_feijao',
                name: 'Escolha do Feijão',
                badge: '1 escolha obrigatória',
                required: true,
                min_choice: 1,
                max_choice: 1,
                free_choices: 1,
                defaultSelected: true,
                items: [
                    { name: 'Feijão carioca', price: 0, defaultSelected: true },
                    { name: 'Feijão preto', price: 0, defaultSelected: true },
                    { name: 'Feijão carioca com bacon', price: 2.00, defaultSelected: true }
                ]
            },
            {
                key: 'guarnicoes_marmita',
                name: 'Guarnições',
                badge: 'Múltiplas escolhas',
                required: false,
                min_choice: 0,
                max_choice: 4,
                free_choices: 2,
                defaultSelected: true,
                items: [
                    { name: 'Farofa temperada', price: 0, defaultSelected: true },
                    { name: 'Batata rústica', price: 0, defaultSelected: true },
                    { name: 'Salada do dia', price: 0, defaultSelected: true },
                    { name: 'Legumes', price: 0, defaultSelected: true },
                    { name: 'Purê de batata', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'proteina_marmita',
                name: 'Proteína',
                badge: '1 escolha obrigatória',
                required: true,
                min_choice: 1,
                max_choice: 1,
                free_choices: 1,
                defaultSelected: true,
                items: [
                    { name: 'Carne bovina', price: 0, defaultSelected: true },
                    { name: 'Frango', price: 0, defaultSelected: true },
                    { name: 'Linguiça', price: 0, defaultSelected: true },
                    { name: 'Carne suína', price: 0, defaultSelected: true }
                ]
            }
        ]
    },
    {
        id: 'cafeteria',
        name: 'Cafeteria',
        badge: 'Cafés & Doces',
        svgIcon: 'coffee',
        themeColor: '#854D0E',
        description: 'Cafés especiais, lanches, salgados e doces finos.',
        botMessages: {
            welcome: 'Olá, {nome_cliente}! ☕ Seja bem-vindo à {nome_loja}! O aroma do café especial te espera! Veja nossas opções de bebidas, doces e salgados no link: 👇',
            upsell: 'Que tal acompanhar seu café com um pão de queijo quentinho da canastra ou um cookie com gotas de chocolate? 🥐🍪'
        },
        groups: [
            {
                key: 'tipo_leite',
                name: 'Tipo de Leite',
                badge: '1 escolha obrigatória',
                required: true,
                min_choice: 1,
                max_choice: 1,
                free_choices: 1,
                defaultSelected: true,
                items: [
                    { name: 'Integral', price: 0, defaultSelected: true },
                    { name: 'Desnatado', price: 0, defaultSelected: true },
                    { name: 'Sem lactose', price: 0, defaultSelected: true },
                    { name: 'Vegetal', price: 3.00, defaultSelected: true }
                ]
            },
            {
                key: 'acucar_adocante',
                name: 'Açúcar / Adoçante',
                badge: '1 escolha obrigatória',
                required: true,
                min_choice: 1,
                max_choice: 1,
                free_choices: 1,
                defaultSelected: true,
                items: [
                    { name: 'Açúcar', price: 0, defaultSelected: true },
                    { name: 'Adoçante', price: 0, defaultSelected: true },
                    { name: 'Sem açúcar', price: 0, defaultSelected: true }
                ]
            },
            {
                key: 'extras_cafe',
                name: 'Extras',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 5,
                free_choices: 0,
                defaultSelected: true,
                items: [
                    { name: 'Chantilly', price: 2.00, defaultSelected: true },
                    { name: 'Calda de chocolate', price: 2.00, defaultSelected: true },
                    { name: 'Canela', price: 0, defaultSelected: true },
                    { name: 'Chocolate em pó', price: 0, defaultSelected: true },
                    { name: 'Caramelo', price: 2.00, defaultSelected: true }
                ]
            },
            {
                key: 'acompanhamentos_cafe',
                name: 'Acompanhamentos',
                badge: 'Opcional',
                required: false,
                min_choice: 0,
                max_choice: 5,
                free_choices: 0,
                defaultSelected: false,
                items: [
                    { name: 'Croissant', price: 7.00, defaultSelected: true },
                    { name: 'Pão de queijo', price: 4.50, defaultSelected: true },
                    { name: 'Cookie', price: 5.00, defaultSelected: true },
                    { name: 'Brownie', price: 6.50, defaultSelected: true }
                ]
            }
        ]
    }
];

export function getNicheTemplate(nicheId) {
    return NICHE_TEMPLATES.find(n => n.id === nicheId) || NICHE_TEMPLATES[0];
}
